import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('EarnedPoints').create(({ theme }) => ({
  root: {
    background: 'rgb(52, 58, 84)',
    display: 'flex',
    width: 'fit-content',
    alignItems: 'center',
    height: '20px',
    padding: '0 5px',
    gap: '14x',
    borderRadius: '12px',

    span: {
      fontWeight: 450,
      fontSize: '13px',
      textWrap: 'nowrap',
      lineHeight: '18px',
      textAlign: 'center',
      color: theme.colors.text.primary,
    },
  },
}))
